import { render } from "./PeriodDatePicker.vue?vue&type=template&id=70709bb4"
import script from "./PeriodDatePicker.vue?vue&type=script&lang=js"
export * from "./PeriodDatePicker.vue?vue&type=script&lang=js"

import "./PeriodDatePicker.vue?vue&type=style&index=0&id=70709bb4&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__